module.exports = __webpack_public_path__ + "static/squareone-6acd52c592169cd419906ae42bd68e12.png";